"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _BrightcovePlayer = _interopRequireDefault(require("../BrightcovePlayer/BrightcovePlayer.player"));

var _Modal = require("../Modal/Modal.index");

var _Carousel = _interopRequireDefault(require("./Carousel/Carousel.index"));

var _Gallery = _interopRequireDefault(require("./Gallery.image"));

var _Gallery2 = require("./Gallery.styles");

var _Gallery3 = require("./Gallery.types");

var _Modal2 = _interopRequireDefault(require("./Modal/Modal.index"));

var _Tabs = _interopRequireDefault(require("./Tabs/Tabs.index"));

var _Thumbnails = _interopRequireDefault(require("./Thumbnails/Thumbnails.index"));

var _excluded = ["images", "videos", "productInfo", "useSkeletons", "videoPlayerProps", "theme"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mapImage(image) {
  if ((0, _isString["default"])(image)) {
    return {
      primaryLink: image,
      thumbnail: image,
      type: 'IMAGE'
    };
  }

  return _objectSpread(_objectSpread({}, image), {}, {
    type: 'IMAGE'
  });
}

function mapVideo(video) {
  if ((0, _isString["default"])(video)) {
    return {
      videoId: video,
      thumbnail: video,
      type: 'VIDEO'
    };
  }

  return _objectSpread(_objectSpread({}, video), {}, {
    type: 'VIDEO'
  });
}

var Gallery = function Gallery(_ref) {
  var images = _ref.images,
      videos = _ref.videos,
      productInfo = _ref.productInfo,
      useSkeletons = _ref.useSkeletons,
      videoPlayerProps = _ref.videoPlayerProps,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _ref2 = theme !== null && theme !== void 0 ? theme : {},
      _ref2$gallery = _ref2.gallery;

  _ref2$gallery = _ref2$gallery === void 0 ? {} : _ref2$gallery;
  var _ref2$gallery$useTabs = _ref2$gallery.useTabs,
      useTabs = _ref2$gallery$useTabs === void 0 ? false : _ref2$gallery$useTabs,
      _ref2$gallery$changeO = _ref2$gallery.changeOnHover,
      changeOnHover = _ref2$gallery$changeO === void 0 ? false : _ref2$gallery$changeO;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = (0, _react.useState)('IMAGE'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      viewState = _useState4[0],
      setViewState = _useState4[1];

  var _useModal = (0, _Modal.useModal)({
    isOpen: false
  }),
      isOpen = _useModal.isOpen,
      toggle = _useModal.toggle;

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      initialModalIndex = _useState6[0],
      setInitialModalIndex = _useState6[1];

  var mappedImages = (0, _react.useMemo)(function () {
    return images.map(mapImage);
  }, [images]);
  var mappedVideos = (0, _react.useMemo)(function () {
    return videos.map(mapVideo);
  }, [videos]);

  var _useState7 = (0, _react.useState)([0]),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      loadedImages = _useState8[0],
      setLoadedImages = _useState8[1];

  var showModal = function showModal(index) {
    if (index !== undefined) {
      setInitialModalIndex(index);
    }

    toggle();
  };

  var onCloseModal = function onCloseModal() {
    toggle();
  };

  var loadAndShowImage = function loadAndShowImage(index, item) {
    if (item.type === 'IMAGE') {
      if (!loadedImages.includes(index)) {
        setLoadedImages([].concat((0, _toConsumableArray2["default"])(loadedImages), [index]));
      }
    }

    setViewState(item.type);
    setActiveIndex(index);
  };

  var handleThumbnailHover = function handleThumbnailHover(index, item) {
    if (changeOnHover) {
      loadAndShowImage(index, item);
    }
  };

  var handleThumbnailClick = function handleThumbnailClick(index, item, command) {
    if (useTabs || command) {
      showModal();
    } else {
      loadAndShowImage(index, item);
    }
  }; // be sure to add the 'see more images' overlay as used on bca


  var renderedImages = images.map(function (image, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "gallery-image-".concat(image.primaryLink),
      role: "presentation",
      onTouchStart: function onTouchStart() {// clearInterval(this.swipeTimer);
      },
      onClick: function onClick(event) {
        event.stopPropagation();
        showModal(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
      image: image,
      productInfo: productInfo,
      isLoaded: loadedImages.includes(index),
      theme: theme
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(_Gallery2.Root, rest, isOpen && /*#__PURE__*/_react["default"].createElement(_Modal2["default"], {
    images: images,
    videos: videos,
    isOpen: isOpen,
    loadedImages: loadedImages,
    productInfo: productInfo,
    onClose: onCloseModal,
    setLoadedImages: setLoadedImages,
    initialIndex: initialModalIndex
  }), useTabs && videos.length && images.length && /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    options: [{
      value: 'IMAGE',
      label: 'Photos'
    }, {
      value: 'VIDEO',
      label: 'Videos'
    }],
    onChange: setViewState,
    selected: viewState
  }), images.length && (!useTabs || viewState === 'IMAGE') && /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
    activeIndex: activeIndex
  }, renderedImages), videos.legnth && (!useTabs && !images.length || useTabs && viewState === 'VIDEO') && /*#__PURE__*/_react["default"].createElement(_Gallery2.MainImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_BrightcovePlayer["default"], (0, _extends2["default"])({
    videoId: videos[activeIndex].videoId
  }, videoPlayerProps, {
    classNames: ['video-player']
  }))), /*#__PURE__*/_react["default"].createElement(_Thumbnails["default"], {
    videos: mappedVideos,
    images: mappedImages,
    activeIndex: activeIndex,
    mode: useTabs ? viewState : 'MIXED',
    onThumbnailHover: handleThumbnailHover,
    onThumbnailClick: handleThumbnailClick,
    useSkeletons: useSkeletons
  }));
};

Gallery.propTypes = {
  images: _propTypes["default"].arrayOf(_Gallery3.imageShape),
  videos: _propTypes["default"].arrayOf(_Gallery3.videoShape),
  productInfo: _Gallery3.productInfoShape,
  activeTexture: _propTypes["default"].shape({
    current: _propTypes["default"].shape({
      model: _propTypes["default"].string
    })
  }),
  theme: _propTypes["default"].shape({
    gallery: _Gallery3.galleryTheme
  }),
  useSkeletons: _propTypes["default"].bool,
  videoPlayerProps: _Gallery3.videoPlayerShape
};
Gallery.defaultProps = {
  productInfo: {},
  images: [],
  videos: [],
  activeTexture: undefined,
  theme: undefined,
  useSkeletons: false,
  videoPlayerProps: undefined
};
Gallery.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Gallery",
  "props": {
    "productInfo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "productInfoShape"
      },
      "required": false
    },
    "images": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "imageShape"
        }
      },
      "required": false
    },
    "videos": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "videoShape"
        }
      },
      "required": false
    },
    "activeTexture": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "shape",
            "value": {
              "model": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "gallery": {
            "name": "custom",
            "raw": "galleryTheme",
            "required": false
          }
        }
      },
      "required": false
    },
    "useSkeletons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "videoPlayerProps": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "videoPlayerShape"
      },
      "required": false
    }
  }
};

var _default = /*#__PURE__*/(0, _react.memo)((0, _styledComponents.withTheme)(Gallery));

exports["default"] = _default;